const doT = require('dot');

/**
 * Travel up to the DOM tree until it finds the element that matches the selector.
 * @param  {Object<Element>} elem   Child element to start the search from
 * @param  {String} selector        Parent selector to search
 * @return {Object<Element>}        Return first matching parent, or false
 */
export const getClosest = (elem, selector) => {
  // Get closest match
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) {
      return elem;
    }
  }
  return false;
};

/**
 *  Executes a provided function once for each element in a list (Array, Nodelist ...)
 * @param  {Array} array    Name of the list to loop in
 * @param  {function} fn    Function to execute for each list element
 */
export const forEach = (array, fn) => {
  let i, len;
  for (i = 0, len = array.length; i < len; i++) {
    fn(array[i], i);
  }
};

/**
 * Generates HTML from a template and data
 * @param  {String} tpl   Name of the list to loop in
 * @param  {Object} dat   Data to use to generate template
 * @Return  {String}      Return generated template
 */
export const template = (tpl, data) => {
  // if tpl is already compiled in cache, serve it
  if (tpl in cache) {
    return cache[tpl](data);
  }

  // if cache doesn't exist, create and store it
  const tmp = doT.template(tpl);
  const obj = {};
  obj[tpl] = tmp;
  Object.assign(cache, obj);
  return tmp(data);
};

// Compile is the most expensive task, so we cache the result
const cache = {};